<template>
    <div id="daumContent" role="main" :class="'fancafe_' + tab">
        <div id="cSub">
            <div class="feature_fancafe">
                <div id="fancafe_pann_wrap" class="slick-list">
                    <button type="button" id="getPrev" class="slick-prev ico_cafetop" aria-label="Previous" role="button">Previous</button>
                    <button type="button" id="getNext" class="slick-next ico_cafetop" aria-label="Next" role="button">Next</button>

                    <div class="slideDataWrap">
                        <div id="slideData"></div>
                    </div>

                    <div id="fancafe_pann" class="slick-track" role="listbox"></div>
                </div>
                <div class="snb_fancafe">
                    <div class="inner_snb">
                        <h3 class="screen_out">팬카페 서브메뉴</h3>
                        <ul class="list_snb"  v-on:click="setTab">
                            <li class="fandom_snb">팬덤랭킹</li>
                            <li class="cafe_snb">카페</li>
                            <li class="cheer_snb">응원</li>
                        </ul>

                        <strong class="screen_out">팬카페 안내메뉴</strong>
                        <ul class="group_links">
                            <li>
                                <a href="#none" id="rankingTip" class="btn_info" @click.prevent.stop="openLayer">팬덤랭킹이란?</a>
                                <div class="layer_info" id="rankingTip_layer" v-show="openedLayer === 'rankingTip'">
                                    팬덤랭킹은 스타 응원하기, 팬카페 활동 점수<br>
                                    (새글, 방문, 가입)를 중요도에 따라 가중치를<br>
                                    적용하여 합산, 반영합니다.

                                    <a href="https://cafe.daum.net/supporters/Mhj5/22" target="_blank" class="link_detail">자세히 보기</a>
                                    <button class="btn_close ico_cafetop">레이어 닫기</button>
                                </div>
                            </li>
                            <li>
                                <a href="#none" id="supportTip" class="btn_info" @click.prevent.stop="openLayer">지원안내</a>
                                <div class="layer_info" id="supportTip_layer" v-show="openedLayer === 'supportTip'">
                                    공식팬카페로 선정되면<br>
                                    공식 엠블럼, 검색 우선 소개, 응원 위젯 등<br>
                                    다양한 혜택을 제공합니다.

                                    <a href="https://cafe.daum.net/supporters/Mhj5/13" target="_blank" class="link_detail">자세히 보기</a>
                                    <button class="btn_close ico_cafetop">레이어 닫기</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div id="cMain">
            <fancafe-list></fancafe-list>
        </div>
    </div>
</template>

<script>
import FancafeList from './components/fancafe/FancafeList.vue';
import { mapState } from 'vuex';
import $ from 'jquery';

export default {
    components: {
        FancafeList
    },
    computed: {
        ...mapState(['tab', 'openedLayer'])
    },
    methods: {
        setTab(e) {
            const tab = e.target.className.replace("_snb", "");
            this.$store.commit("setTab", tab);
        },
        openLayer(e) {
            const layer = e.currentTarget.id;
            this.$store.commit("setOpenedLayer", layer);
        },
        closeLayer() {
            this.$store.commit("setOpenedLayer", "");
        }
    },
    mounted() {
        $("body").on("click", this.closeLayer); // 컴포넌트 밖 여백을 눌러도 레이어가 닫히게 body에 이벤트 걸어둠
    }
}
</script>

<style type="text/css">
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .opt_g2 .opt_selected .tf_opt { width: 135px; }
    .opt_g2 .opt_selected .txt_selected { float: left; min-width: 110px; }
    .snb_fancafe .list_snb li:first-child { padding-right: 15px; }
    .opt_g .opt_selected .ico_arrow { margin-left: 6px; }
    .item_fancafe_top .box_item .tit_item { margin-top: 19px; line-height: 27px; }
    .item_fancafe_top .box_item .list_data { margin-top: 2px; }
    #optCateText, #optSortSelected { margin-top: 0; }
    .feature_fancafe .slick-data .ico_info { padding: 1px 5px 2px; }
    .fancafe_recommend .item_list { padding-top: 10px; }
    .fancafe_recommend .item_list .desc_list { padding-top: 16px; }
    .fancafe_recommend .item_list .txt_list { margin-top: -4px; height: 20px; }
    .fancafe_cheer .info_cheer { margin: 3px 0 2px; }
    .group_util .group_noresult { margin-top: 182px; }
    #searchStar:-ms-input-placeholder { color: #b6b6b6; }
}
</style>
